import { useEffect, useState } from "react";
import ConvertSDK, { ConvertConfig, LogLevel } from "@convertcom/js-sdk";

const useConvert = (): ConvertSDK | null => {
  const [convert, setConvert] = useState<ConvertSDK | null>(null);

  useEffect(() => {
    // Set configs for the Convert SDK
    const config = {
      sdkKey: process.env.NEXT_PUBLIC_CONVERT_SDK_KEY,
      environment: process.env.NEXT_PUBLIC_ENV_NAME ?? "local",
      logger: {
        logLevel: LogLevel.SILENT,
        customLoggers: [], // Allows 3rd party loggers to be passed
      },
      bucketing: {
        hash_seed: 9999, // murmurhash seed
        max_traffic: 10000, // max hash (representing 100% traffic allocation)
        excludeExperienceIdHash: false, // whether to ignore prefixing the generated hash with the experience id
      },
      dataStore: null, // Allows 3rd party data store to be passed (optional)
      dataRefreshInterval: 300000, // in milliseconds (5 minutes)
      events: {
        batch_size: 10, // max network requests to be released per call
        release_interval: 10000, // time in milliseconds between network releasing queue (including the initial release)
      },
      network: {
        tracking: true, // can be set to false to disable tracking events
        cacheLevel: "default", // can be set to 'low' for short-lived cache (for development purposes only)
        source: "js-sdk", // string identifier indicating the source of network requests
      },
    } as ConvertConfig;

    const convertInstance = new ConvertSDK(config);
    setConvert(convertInstance);
  }, []);

  return convert;
};

export default useConvert;
